import { http } from "../../../components/services/httpService";

export async function fetchRefCompetencesCategories() {
    const token = localStorage.getItem( "token" );
    const res = await http(
        'ref/competences/categories/all', {
            headers: { Authorization: `Bearer ${token}` },
        } );
    if ( !res.ok ) {
        throw new Error( `Failed to fetch reference: competences categories: ${res.status}` );
    }
    return await res.json();
}
